import { TraitSide } from './Contexts/ConstantsCollection.js';
import theme from '../../theme.js';

const baseStyle = {
  control: provided => ({
    ...provided,
    minHeight: '20px',
    padding: '0px',
    border: '2px solid black',
    borderRadius: '8px',
  }),
  singleValue: provided => ({
    ...provided,
    height: '100%',
    width: '100%',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  }),
  input: provided => ({
    ...provided,
    margin: '0px',
    padding: '0px',
  }),
  menuPortal: provided => ({
    ...provided,
    zIndex: 9999,
  }),
  multiValue: provided => ({
    ...provided,
    height: '15px',
  }),
};

export const compactStyles = baseColor => ({
  ...baseStyle,
  control: provided => ({
    ...baseStyle.control(provided),
    fontSize: '12px',
    height: '30px',
    width: '70px',
    padding: '0px',
    borderRadius: '3px 0px 0px 8px',
  }),
  menu: provided => ({
    ...provided,
    width: '150px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? state.data?.traitSide === TraitSide.Left
        ? theme.colors.leftSideLight
        : state.data?.traitSide === TraitSide.Right
          ? theme.colors.rightSideLight
          : baseColor
      : 'white',
    color: 'black',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
});

export const defaultStyles = baseColor => ({
  ...baseStyle,
  control: provided => ({
    ...baseStyle.control(provided),
    padding: '4px',
  }),
  menu: provided => ({
    ...provided,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? baseColor
      : state.isFocused
        ? state.data?.traitSide === TraitSide.Left
          ? theme.colors.leftSideLight
          : state.data?.traitSide === TraitSide.Right
            ? theme.colors.rightSideLight
            : baseColor
        : 'white',
    color: 'black',
  }),
});

export function stylesFor(variant = 'default', baseColor = 'lightgrey') {
  switch (variant) {
    case 'compact':
      return compactStyles(baseColor);
    case 'default':
    default:
      return defaultStyles(baseColor);
  }
}

export default stylesFor;
